import { SettingsApis } from "../apis/SettingsApi";

export const SettingsServices = {
  fetchUserStripeAccount: async (profile) => {
    const response = await SettingsApis.fetchUserStripeAccount(profile);
    if (!response.success) {
      return {
        status: 400,
        success: false,
        message: "There was an error updating your address",
      };
    }

    return { success: true, status: response.status, data: response.data };
  },

  updateProfile: async (formDataToSend) => {
    const response = await SettingsApis.updateProfile(formDataToSend);
    if (!response.success) {
      return {
        status: 400,
        success: false,
        message: "There was an error updating your address",
      };
    }

    return { success: true, status: response.status, response };
  },

  updateStoreLogo: async (formData) => {
    const response = await SettingsApis.updateStoreLogo(formData);
    console.log(response)
    if (!response.success) {
      return {
        status: 400,
        success: false,
        message: "There was an error updating your address",
      };
    }

    return { success: true, status: response.status, data: response.data };
  },

  emailSupport: async (formData) => {
    const response = await SettingsApis.sendSupportMessage(formData);
    if (!response.success) {
      return {
        status: 400,
        success: false,
        message: "There was an error updating your address",
      };
    }

    return { success: true, status: response.status, data: response.data };
  },
};
